'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { getAccount } from '@/lib/auth'

export default function Home() {
  const router = useRouter()

  useEffect(() => {
    let mounted = true
    getAccount().then((acc) => {
      if (!mounted) return
      if (acc) router.replace('/dashboard')
      else router.replace('/login')
    })
    return () => { mounted = false }
  }, [router])

  return null
}
